<template>
  <div class="project-box">
    <div class="project-left margin-right-1rem">
      <c-block-box
        title="项目基本信息"
        class="margin-bottom-1rem"
      >
        <div class="essential-info">
          <div class="essential-info--box">
            <span class="lable">价值目标</span>
            <span class="value">{{ projectDetail.project.projectGoal }}</span>
          </div>
          <div class="essential-info--box">
            <span class="lable">项目周期</span>
            <span class="value">{{ $cUtils.format.formatDate(projectDetail.project.projectStartTime, 'yyyy年MM月dd日') }} - {{ $cUtils.format.formatDate(projectDetail.project.projectEndTime, 'yyyy年MM月dd日') }}</span>
          </div>
          <div class="essential-info--box">
            <span class="lable">项目成员</span>
            <span class="value">{{ projectDetail.project.projectLeader }}</span>
          </div>
        </div>
      </c-block-box>
      <c-block-box
        title="月总营收"
        class="margin-bottom-1rem"
      >
        <div class="monthly-revenue">
          <div class="revenue-box">
            <div class="revenue-flex margin-right-1rem">
              <div class="name">月总营收</div>
              <div class="value">{{ projectDetail.monthIncome }}<span>万元</span></div>
              <div class="tendency">
                <div class="tendency-text">
                  <span>月环比</span>
                  <img :src="upsAndDowns( projectDetail.monthRatio || 0 )" />
                  <em>{{ percentage( projectDetail.monthRatio || 0 ) }}%</em>
                </div>
              </div>
            </div>
            <div class="revenue-flex" style="background: #089EAD">
              <div class="name">月成本</div>
              <div class="value">{{ projectDetail.monthCost }}<span>万元</span></div>
              <c-target-rate
                label="投入产出比"
                width="14rem"
                :num="percentage(projectDetail.monthInOutRatio || 0)"
              ></c-target-rate>
            </div>
          </div>
          <div class="revenue-title">月营收趋势</div>
          <ChartBarLine
            id="dep-revenue-trend"
            width="100%"
            height="17rem"
            :option="shareLine"
          ></ChartBarLine>
        </div>
      </c-block-box>
    </div>
    <div class="project-right">
      <c-block-box
        title="年累计营收"
      >
        <div style="height: 46.3rem">
          <div class="revenue-box">
            <div class="revenue-flex margin-right-1rem">
              <div class="name">年总营收</div>
              <div class="value">{{ projectDetail.yearIncome || 0 }}<span>万元</span></div>
            </div>
            <div class="revenue-flex" style="background: #089EAD">
              <div class="name">年成本</div>
              <div class="value">{{ projectDetail.yearCost || 0 }}<span>万元</span></div>
              <c-target-rate
                label="投入产出比"
                width="17rem"
                :num="percentage(projectDetail.yearInOutRatio || 0)"
              ></c-target-rate>
            </div>
          </div>
          <div class="revenue-title">年营收趋势</div>
          <ChartBarLine
            id="dep-revenue-trend1"
            width="100%"
            height="32.7rem"
            :option="shareLine1"
          ></ChartBarLine>
        </div>
      </c-block-box>
    </div>
  </div>
</template>

<script>
import common from '@/mixins/common.js'
import ChartBarLine from '@/components/echarts/line2'
export default {
  mixins: [common],
  components: {
    ChartBarLine
  },
  props: {},
  data () {
    return {
      projectDetail: {
        project: {}
      },
      shareLine: {
        config: {},
        data: null
      },
      shareLine1: {
        config: {},
        data: null
      }
    }
  },
  computed: {
    isAndroid () {
      return this.$store.state.app.isAndroid
    }
  },
  methods: {
    getLineData (data, name) {
      const keyData = Object.keys(data)
      const dataLine = {
        config: {
          legend: {
            right: 20,
            top: 0
          },
          grid: {
            left: 20,
            right: 20,
            bottom: 0,
            top: 30,
            containLabel: true
          },
          boundaryGap: true,
          yAxis: [{
            name: '万元',
            type: 'value',
            splitLine: {
              lineStyle: {
                color: 'rgba(255,255,255,0.05)'
              }
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: 'rgba(255,255,255,0.1)'
              }
            },
            axisLabel: {
              textStyle: {
                color: 'rgba(255,255,255,.6)',
                fontSize: 12
              }
            },
            nameTextStyle: {
              color: '#999',
              fontSize: 12
            },
            splitArea: {
              'show': false
            }
          }],
          xData: data[keyData[0]].date.map(item => {
            return this.$cUtils.format.formatDate(item, name === 'shareLine1' ? 'MM月' : 'MM月dd')
          })
        },
        data: keyData.map(item => {
          return {
            name: item,
            data: data[item].data,
            lineStyle: {
              type: item === '成本' ? 'dashed' : 'solid',
              width: !this.isAndroid ? 2 : 0.5
            },
            areaStyle: item === '成本' ? null : {
              opacity: 0.2
            },
            symbol: 'none',
            type: 'line'
          }
        })
      }
      this[name] = dataLine
    },
    getProject () {
      const choiceDate = JSON.parse(sessionStorage.getItem('toggleDate'))
      this.$service.fetch({
        url: 'api/ssp/dashboard',
        params: {
          month: choiceDate.time,
          id: this.$route.query.id
        }
      }).then(res => {
        this.projectDetail = res
        this.getLineData(res.month, 'shareLine')
        this.getLineData(res.year, 'shareLine1')
        this.$nextTick(() => {
          this.$parent.bindKey(this.isAndroid ? 'back' : 'select-mounth')
        })
      })
    }
  },
  activated () {
    this.getProject()
  },
  created () {
  }
}
</script>

<style lang="stylus" scoped>
.project-box
  display flex
  .revenue-title
    line-height 2rem
    font-size 1rem
    color #fff
    padding 0 1rem
  .project-left
    width 43.4rem
    .essential-info
      height 9.2rem
      padding 1.5rem 1rem
      .essential-info--box
        display flex
        line-height 1.35rem
        padding-bottom .6rem
        .lable
          width 5rem
          color rgba(255, 255, 255, .8)
          font-size 1rem
        .value
          flex 1
          font-size .9rem
          color rgba(255, 255, 255, .6)
    .monthly-revenue
      height 30.7rem

  .project-right
    flex 1
.revenue-box
  display flex
  padding 1rem
  .revenue-flex
    flex 1
    height 7.4rem
    background #0075ff
    border-radius 0.4rem
    padding .8rem 1rem
    .name
      height 1.5rem
      line-height 1.5rem
      color #fff
      font-size 1.2rem
    .value
      line-height 4.5rem
      height 4.5rem
      color #fff
      font-size 2.4rem
      span
        font-size 1.4rem
    .tendency
      padding-top .5rem
      display flex
      .tendency-text
        line-height 1rem
        height 1rem
        font-size .9rem
        color rgba(255, 255, 255, 0.8)
        white-space nowrap
        padding-right 1rem
        img
          width .6rem
          vertical-align middle
          margin 0 .4rem
>>>.c-target-rate
  height 1rem
  line-height 1rem
  padding-top .5rem
  .c-progress
    margin-top .125rem
</style>
